class InfiniteScrollTrigger extends HTMLElement {
  constructor() {
    super();

    this._observer = null;
    this._loading = false;
    this._setupTimeout = null;
  }

  connectedCallback() {
    if (!this.querySelector('.infinite-scroll-spinner')) {
      const spinner = document.createElement('div');

      spinner.className = 'infinite-scroll-spinner';
      this.appendChild(spinner);
    }

    const delay = this.hasAttribute('data-delayed') ? 1000 : 0;

    this._setupTimeout = setTimeout(() => {
      if (this.isConnected) this._setupObserver();
    }, delay);
  }

  disconnectedCallback() {
    clearTimeout(this._setupTimeout);

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  _setupObserver() {
    this._observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting && !this._loading) {
          this._loading = true;
          this._observer.disconnect();
          this._observer = null;
          this._loadPage();
        }
      },
      { rootMargin: '200px' }
    );

    this._observer.observe(this);
  }

  async _loadPage() {
    const pageUrl = this.dataset.nextPageUrl || this.dataset.prevPageUrl;
    const isNext = !!this.dataset.nextPageUrl;

    if (!pageUrl) return;

    const sectionContainer = document.getElementById('main-collection-content');
    const sectionId = sectionContainer ? sectionContainer.dataset.id : null;

    if (!sectionId) return;

    const loader = document.querySelector('[data-loader]');

    loader?.classList.remove('hidden');
    this.classList.add('is-loading');

    try {
      const fetchUrl = new URL(pageUrl, window.location.origin);

      fetchUrl.searchParams.set('section_id', sectionId);

      const response = await fetch(fetchUrl.toString());
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newOl = parsed.querySelector('ol[data-page]');

      if (!newOl) return;

      const newPage = parseInt(newOl.dataset.page, 10);

      if (document.querySelector(`ol[data-page="${newPage}"]`)) return;

      const grid = document.getElementById('main-collection-product-grid');

      if (!grid) return;

      const newNextTrigger = parsed.querySelector('infinite-scroll-trigger[data-next-page-url]');
      const newPrevTrigger = parsed.querySelector('infinite-scroll-trigger[data-prev-page-url]');

      this.remove();

      if (isNext) {
        grid.appendChild(newOl);

        if (newNextTrigger && !document.querySelector(`ol[data-page="${newPage + 1}"]`)) {
          newNextTrigger.setAttribute('data-delayed', '');
          grid.appendChild(newNextTrigger);
        }
      } else {
        const firstOl = grid.querySelector('ol[data-page]');

        grid.insertBefore(newOl, firstOl ?? grid.firstChild);

        if (newPrevTrigger && !document.querySelector(`ol[data-page="${newPage - 1}"]`)) {
          newPrevTrigger.setAttribute('data-delayed', '');
          grid.insertBefore(newPrevTrigger, newOl);
        }
      }

    } catch (err) {
      this._loading = false;
      this.classList.remove('is-loading');

      if (this.isConnected) this._setupObserver();
    } finally {
      loader?.classList.add('hidden');
    }
  }
}

if (!customElements.get('infinite-scroll-trigger')) {
  customElements.define('infinite-scroll-trigger', InfiniteScrollTrigger);
}